import { Grid, styled } from '@mui/material'

const FirstLayoutGrid = styled(Grid)({
    position: 'absolute',
    bottom: '0',
    top: '0',
    right: '0',
    left: '0',
    background:
        'radial-gradient(circle, rgba(90, 223, 180, 1) 0%, rgba(18, 174, 133, 1) 50%, rgba(16, 172, 132, 1) 100%)',
    textAlign: 'center',
})

export default FirstLayoutGrid
